// extracted by mini-css-extract-plugin
export default {"whiteTextInput":"uRNGxves_IoeHUaVOifH"};